const findSelectedOption = ({ options = [], value, getIdByValue }) => {
    const texto = String(value || '');

    if (!texto) {
        return { id: null, selected: null };
    }

    let selected =
        options.find(
            (opt) =>
                String(opt?.descricao || '')
                    .trim()
                    .toLowerCase() === texto?.toLowerCase()
        ) || null;

    let selectedId = selected?.id ? Number(selected.id) : null;

    if (!selected && typeof getIdByValue === 'function') {
        const selectedIdRaw = getIdByValue(texto);
        selectedId = selectedIdRaw ? Number(selectedIdRaw) : null;

        if (selectedId) {
            selected = options.find((opt) => Number(opt?.id) === Number(selectedId)) || null;
        }
    }

    const id = selected?.id ? Number(selected.id) : (selectedId ?? null);
    const selectedSafe = selected || (id ? { id, descricao: texto, label: '' } : null);

    return { id, selected: selectedSafe };
};

export const setByPath = (obj, path, value) => {
    if (!path || typeof path !== 'string') return { ...(obj || {}) };
    if (!path.includes('.')) return { ...(obj || {}), [path]: value };

    const keys = path.split('.');
    const out = { ...(obj || {}) };
    let cur = out;

    for (let i = 0; i < keys.length - 1; i++) {
        const k = keys[i];
        cur[k] = { ...(cur[k] || {}) };
        cur = cur[k];
    }

    cur[keys[keys.length - 1]] = value;
    return out;
};

export async function handleParceiroLookup(value, deps = {}) {
    const { empresaId, consultaFn, setOptions, setTextState, getIdByValue, condicao, targetKey, setTargetState, objectKey } =
        deps;

    const texto = String(value || '');

    if (typeof setTextState === 'function') {
        setTextState((prev) => ({ ...(prev || {}), descricao: texto }));
    }

    if (!texto) {
        if (typeof setOptions === 'function') setOptions([]);
        if (typeof setTargetState === 'function') {
            setTargetState((prev) => ({
                ...prev,
                [targetKey]: null,
                ...(objectKey ? { [objectKey]: {} } : {}),
            }));
        }
        return { id: null, selected: null, options: [] };
    }

    let options = [];

    if (typeof consultaFn === 'function') {
        options = await consultaFn({
            empresaId,
            tabela: 'Pessoa',
            condicao: condicao ?? null,
            filtro: texto,
        });

        options = Array.isArray(options) ? options : [];

        if (typeof setOptions === 'function') {
            setOptions(options);
        }
    }

    const { id, selected } = findSelectedOption({
        options,
        value: texto,
        getIdByValue,
    });

    if (typeof setTargetState === 'function') {
        setTargetState((prev) => ({
            ...prev,
            [targetKey]: id,
            ...(objectKey && selected ? { [objectKey]: selected } : {}),
        }));
    }

    if (typeof setTextState === 'function' && selected) {
        setTextState(selected);
    }

    return { id, selected, options };
}

export async function handleColaboradorLookup(value, deps = {}) {
    const {
        empresaId,
        tipoColaborador,
        consultaFn,
        setOptions,
        setColaboradorState,
        getIdByValue,
        setTargetState,
        targetKey = 'colaboradorId',
        objectKey,
        obrigaPlantao,
        dataPlantao,
    } = deps;

    const texto = String(value || '');

    if (typeof setColaboradorState === 'function') {
        setColaboradorState((prev) => ({ ...(prev || {}), descricao: texto }));
    }

    if (!texto) {
        if (typeof setOptions === 'function') setOptions([]);
        if (typeof setTargetState === 'function') {
            setTargetState((prev) => ({
                ...prev,
                [targetKey]: null,
                ...(objectKey ? { [objectKey]: {} } : {}),
            }));
        }
        return { id: null, selected: null, options: [] };
    }

    let options = [];

    if (typeof consultaFn === 'function') {
        options = await consultaFn({
            empresaId,
            filtro: texto,
            ativo: true,
            tipo: null, //tipoColaborador,
            plantaoId: dataPlantao?.plantaoId,
            plantaoTipoId: dataPlantao?.plantaoTipoId,
            obrigaPlantao,
        });

        options = Array.isArray(options) ? options : [];

        if (typeof setOptions === 'function') {
            setOptions(options);
        }
    }

    const { id, selected } = findSelectedOption({
        options,
        value: texto,
        getIdByValue,
    });

    if (typeof setTargetState === 'function') {
        setTargetState((prev) => ({
            ...prev,
            [targetKey]: id,
            ...(objectKey && selected ? { [objectKey]: selected } : {}),
        }));
    }

    if (typeof setColaboradorState === 'function' && selected) {
        setColaboradorState(selected);
    }

    return { id, selected, options };
}

export async function handleParceiroImovelLookup(value, deps = {}) {
    const {
        empresaId,
        consultaFn,
        setOptions,
        setTextState,
        getIdByValue,
        targetKey,
        setTargetState,
        objectKey,
        flags = {},
        funcionarioId = null,
    } = deps;

    const texto = String(value || '');

    if (typeof setTextState === 'function') {
        setTextState((prev) => ({ ...(prev || {}), descricao: texto }));
    }

    if (!texto) {
        if (typeof setOptions === 'function') setOptions([]);
        if (typeof setTargetState === 'function') {
            setTargetState((prev) => ({
                ...prev,
                [targetKey]: null,
                ...(objectKey ? { [objectKey]: {} } : {}),
            }));
        }
        return { id: null, selected: null, options: [] };
    }

    let options = [];

    if (typeof consultaFn === 'function') {
        options = await consultaFn(
            empresaId,
            texto,
            flags.locador ?? null,
            flags.locatario ?? null,
            flags.fiador ?? null,
            funcionarioId ?? null,
            flags.administrador ?? null
        );

        options = Array.isArray(options) ? options : [];

        if (typeof setOptions === 'function') {
            setOptions(options);
        }
    }

    const { id, selected } = findSelectedOption({
        options,
        value: texto,
        getIdByValue,
    });

    if (typeof setTargetState === 'function') {
        setTargetState((prev) => ({
            ...prev,
            [targetKey]: id,
            ...(objectKey && selected ? { [objectKey]: selected } : {}),
        }));
    }

    if (typeof setTextState === 'function' && selected) {
        setTextState(selected);
    }

    return { id, selected, options };
}
